import { MessageCircle } from "lucide-react";
import { waLink } from "../lib/site";

export default function WhatsAppFloat() {
  return (
    <a
      href={waLink("Hi Saarthva, I have a sourcing requirement for my business.")}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-float-button"
      aria-label="Chat with Saarthva on WhatsApp"
      className="group fixed bottom-6 right-6 z-50 flex items-center gap-0 rounded-full bg-[#25D366] text-white shadow-xl shadow-emerald-900/20 hover:shadow-2xl transition-all"
    >
      <span className="max-w-0 overflow-hidden group-hover:max-w-[180px] transition-all duration-300 whitespace-nowrap">
        <span className="pl-4 text-sm font-semibold">Chat with Saarthva</span>
      </span>
      <span className="relative grid place-items-center w-14 h-14">
        <MessageCircle className="w-6 h-6" />
        <span className="absolute top-2 right-2 w-2.5 h-2.5 rounded-full bg-saffron border-2 border-[#25D366]" />
      </span>
    </a>
  );
}
